import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/navigation-pic-1.png';
import _imports_1 from '@/assets/img/navigation-pic-2.png';
import _imports_2 from '@/assets/img/navigation-pic-3.png';
import _imports_3 from '@/assets/img/navigation-pic-4.png';
import _imports_4 from '@/assets/img/navigation-pic-5.png';
const _withScopeId = n => (_pushScopeId("data-v-ceaa2ff4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "h-[95px] bg-white mb-[16px]"
};
const _hoisted_2 = {
  class: "h-[95px] p-[17px] float-left"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "h-[95px] px-[15px] pt-[20px] float-left"
};
const _hoisted_5 = {
  class: "text-lg font-bold mb-[5px] text-[#3D3D3D]"
};
const _hoisted_6 = {
  class: "text-sm mb-[8px] text-[#409EFF] text-[12px]"
};
const _hoisted_7 = {
  class: "h-[95px] pr-[15px] pt-[22px] float-end"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-[3px] text-right text-[10px] text-[#767676]"
}, "登录时间", -1));
const _hoisted_9 = {
  class: "mb-[3px] text-right text-[10px] text-[#767676]"
};
const _hoisted_10 = {
  class: "mb-[3px] text-right text-[10px] text-[#767676]"
};
const _hoisted_11 = {
  class: "h-[140px] bg-white mb-[16px] p-[10px]"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[18px] text-[#3D3D3D] font-bold mb-[10px]"
}, "数据统计", -1));
const _hoisted_13 = {
  class: "h-[65px] p-[10px] float-left"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm mb-[2px] text-[#FFFFFF] text-[12px]"
}, "待审核", -1));
const _hoisted_15 = {
  class: "text-xl text-[#FFFFFF] text-[16px]"
};
const _hoisted_16 = {
  class: "h-[65px] p-[10px] float-left"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm mb-[2px] text-[#FFFFFF] text-[12px]"
}, "已审核", -1));
const _hoisted_18 = {
  class: "text-xl text-[#FFFFFF] text-[16px]"
};
const _hoisted_19 = {
  class: "h-[65px] p-[10px] float-left"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm mb-[2px] text-[#FFFFFF] text-[12px]"
}, "会议", -1));
const _hoisted_21 = {
  class: "text-xl text-[#FFFFFF] text-[12px]"
};
const _hoisted_22 = {
  class: "h-[65px] p-[10px] float-left"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm mb-[2px] text-[#FFFFFF] text-[12px]"
}, "今日日程", -1));
const _hoisted_24 = {
  class: "text-xl text-[#FFFFFF] text-[16px]"
};
const _hoisted_25 = {
  class: "h-[595px] bg-white p-[15px]"
};
const _hoisted_26 = {
  class: "week-calendar"
};
const _hoisted_27 = {
  class: "w-[100px] h-[32px] leading-[30px]"
};
const _hoisted_28 = {
  class: "mt-[20px] px-[20px] list-steps"
};
const _hoisted_29 = {
  class: "max-h-[300px] overflow-y-auto custom-scrollbar"
};
const _hoisted_30 = {
  class: "text-[#007dff]"
};
const _hoisted_31 = {
  class: "text-[#000] text-[14px] mb-[8px] line-clamp-1 font-bold"
};
const _hoisted_32 = {
  class: "text-[#767676] text-[12px] mb-[8px] line-clamp-1"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[12px] mb-[8px] line-clamp-1"
}, " 地点1 ", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-[15px] h-[15px] bg-[#007dff] rounded-[50%]"
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-[20px] px-[20px]"
}, null, -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[18px] text-[#3D3D3D] p-[15px]"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-bold"
}, "快捷导航")], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[14px] text-center mt-[5px]"
}, "合同流转", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[14px] text-center mt-[5px]"
}, "物资领用", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[14px] text-center mt-[5px]"
}, "调休申请", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[14px] text-center mt-[5px]"
}, "用印申请", -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-[#767676] text-[14px] text-center mt-[5px]"
}, "加班申请", -1));
const _hoisted_42 = {
  class: "h-[280px] bg-white mb-[16px]"
};
const _hoisted_43 = {
  class: "text-[18px] text-[#3D3D3D] p-[15px]"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-bold"
}, "公告通知", -1));
const _hoisted_45 = {
  class: "max-h-[200px] overflow-y-auto custom-scrollbar"
};
const _hoisted_46 = ["onClick"];
const _hoisted_47 = {
  key: 0,
  class: "bg-gradient-to-r from-[#FFC300] to-[#FF7B00] text-[#ffffff] border-radius-[50%] px-[5px] py-[2px] mr-[5px] rounded-t-lg rounded-br-lg"
};
const _hoisted_48 = {
  class: "h-[445px] bg-white mb-[16px] p-[15px]"
};
const _hoisted_49 = {
  class: "text-[18px] text-[#3D3D3D]"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-bold"
}, "会议日程", -1));
const _hoisted_51 = {
  class: "color-[#767676] text-[14px] float-right"
};
const _hoisted_52 = {
  class: "mt-[10px] mb-[20px]"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-[12px]"
}, "会议数:", -1));
const _hoisted_54 = {
  class: "text-[24px]"
};
const _hoisted_55 = {
  class: "max-h-[300px] overflow-y-auto custom-scrollbar"
};
const _hoisted_56 = {
  class: "h-[50px] mt-[15px] hover:bg-[#ecf5ff] p-[5px]"
};
const _hoisted_57 = {
  class: "float-left border-l-[4px] border-l-[#FF8400] pl-[10px]"
};
const _hoisted_58 = {
  class: "text-[16px] text-[#3D3D3D] font-bold line-clamp-1"
};
const _hoisted_59 = {
  class: "flex items-center"
};
const _hoisted_60 = {
  class: "text-[12px] text-[#aaaaaa] mr-[15px] line-clamp-1"
};
const _hoisted_61 = {
  class: "text-[12px] text-[#aaaaaa] line-clamp-1"
};
const _hoisted_62 = {
  class: "float-right"
};
const _hoisted_63 = {
  class: "text-[#aaaaaa] ml-7"
};
const _hoisted_64 = {
  class: "text-[#aaaaaa]"
};
const _hoisted_65 = {
  class: "h-[400px] bg-white p-[15px]"
};
const _hoisted_66 = {
  class: "max-h-[240px] overflow-y-auto custom-scrollbar"
};
const _hoisted_67 = {
  class: "max-h-[240px] overflow-y-auto custom-scrollbar"
};
const _hoisted_68 = {
  class: "max-h-[240px] overflow-y-auto custom-scrollbar"
};
const _hoisted_69 = {
  class: "max-h-[240px] overflow-y-auto custom-scrollbar"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import moment from 'moment';
import { useCommon } from '@/common/hooks/useCommon';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
import { ElNotification, ElDialog } from 'element-plus';
import { ConsoleController } from "@/api/generated";
import ListOfAssetsList from '@/pages/notice/noticeDialog.vue';
import { ElMessage } from 'element-plus';
import defaultHeaderImg from "@/assets/img/default-header.jpg";
import { useLoginStore } from "@/store";
import { FlowOperationController } from '@/api/flow';
import { useUpload } from "@/common/hooks/useUpload";
import WorkArrangement from "@/pages/welcome/workArrangement.vue";
import NoticeDetails from "@/pages/welcome/noticeDetails.vue";

import { computed } from 'vue';
const __default__ = {
  methods: {
    formatDateByStats(date, type) {
      if (!date) return ''; // 防止空值
      const d = new Date(date); // 将日期字符串或时间戳转换为 Date 对象
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，因此要加 1
      const day = d.getDate().toString().padStart(2, '0');
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      // 返回格式化后的日期时间字符串
      return `${year}-${month}-${day}`;
    }
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const workType = ref('person');
    const leader_value = ref();
    const loginStore = useLoginStore();
    const userInfo = loginStore.userInfo;
    const {
      getUploadFileUrl
    } = useUpload();
    const userInfoDate = ref({});
    const weeklyScheduleList = ref([]);
    const meetingList = ref([]);
    const createTaskList = ref([]);
    const meetingListNumber = ref(0);
    const {
      Dialog
    } = useCommon();
    const dataStatistics = ref({
      pendingReview: 0,
      reviewed: 0,
      meeting: 0,
      weeklySchedule: 0
    });
    const work_options = ref([]);
    const noticeMessageList = ref([]);
    // TODO 切换菜单会触发该方法？
    // 用户头像
    const headerImg = computed(() => {
      if (userInfo && userInfo.headImageUrl) {
        let temp = getUploadFileUrl(userInfo.headImageUrl, {
          filename: userInfo.headImageUrl.filename
        });
        return temp;
      } else {
        return null;
      }
    });
    const existingDataList = ref([]);
    const handleDetailClick = row => {
      console.log('当前行内容:', row);
      row.id = row.weekly_id;
      existingDataList.value = [row];
      let params = {
        saveOnSubmit: false,
        id: row.weekly_id
        // 将当前行数据传递给子页面
        // existingDataList: existingDataList.value,
      };
      Dialog.show('详情', WorkArrangement, {
        area: '800px'
      }, params).then(res => {}).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    const handNoticeDetailsLick = item => {
      console.log('通知公告当前行内容:', item);
      let params = {
        saveOnSubmit: false,
        noticeDetails: item
      };
      Dialog.show('详情', NoticeDetails, {
        area: '800px'
      }, params).then(res => {}).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    //点击通知公告右方详情按钮跳转页面
    const handleMessage = command => {
      command = "noticeMessage";
      router.push({
        name: 'noticeList',
        query: {
          type: command
        }
      });
    };
    //点击创建任务列表跳转页面
    const handleCreateTaskList = command => {
      console.log("command", command);
      if (command.process_definition_key == 'flowMeetingRequest') {
        router.push({
          name: 'flowMeetingRequestOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'notice') {
        router.push({
          name: 'noticeRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'useSeal') {
        router.push({
          name: 'useSealRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'flowLeave') {
        router.push({
          name: 'formLeaveRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'flowOvertime') {
        router.push({
          name: 'flowOvertimeOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'flowRetentionPartyMembership') {
        //跳转党籍保留
        router.push({
          name: 'RetentionPartyMembershipOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'WkcAssetAcquisition') {
        //跳转资产领用
        router.push({
          name: 'WkcAssetAcquisition',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'applyBuy') {
        //跳转采购申请
        router.push({
          name: 'applyBuyRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'wkcAssetRestitution') {
        //跳转资产归还
        router.push({
          name: 'wkcAssetRestitution',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'WkcPurchaseApplication') {
        //跳转采购申购
        router.push({
          name: 'PurchaseApplicationHeader',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'flowBusinessTrip') {
        //跳转出差申请
        router.push({
          name: 'formBusinessTripRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'flowTimeOff') {
        //跳转调休申请
        router.push({
          name: 'formTimeOffRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'PublicServiceReception') {
        //跳转公务接待申请
        router.push({
          name: 'publicServiceReception',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'send') {
        //跳转公务接待申请
        router.push({
          name: 'sendRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'officialaccount') {
        //跳转公务接待申请
        router.push({
          name: 'officialaccountRouteOrder',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      } else if (command.process_definition_key == 'FlowContract') {
        //跳转合同申请
        router.push({
          name: 'ContractAnagementFlow',
          query: {
            workOrderCodeS: command.work_order_code
          }
        });
      }
    };
    //点击待办任务列表跳转页面
    const handPendingReviewListList = command => {
      if (!command) return; // 防止 command 为空
      router.push({
        name: 'formMyTask',
        query: {
          workOrderCodeS: command.workOrderCode,
          processDefinitionName: command.processDefinitionName // 流程名称
        }
      });
    };
    //点击已办任务列表跳转页面
    const handMattersCompletedListList = command => {
      if (!command) return; // 防止 command 为空
      router.push({
        name: 'formMyApprovedTask',
        query: {
          workOrderCodeS: command.workOrderCode,
          processDefinitionName: command.processDefinitionName // 流程名称
        }
      });
    };
    //点击抄送信息列表跳转页面
    const handCcMessageListList = command => {
      if (!command) return; // 防止 command 为空
      console.log("command1111", command);
      const types = "copyMessage";
      // 跳转到 formMyTask 页面，并传递参数
      router.push({
        name: 'CcMessageList',
        query: {
          type: types,
          // workOrderCodeS: command.workOrderCode, // 任务单号
          processDefinitionNameS: command.processDefinitionName // 流程名称
        }
      });
    };
    // 获取当前登录人员的登录信息
    const getUserLoginList = () => {
      return new Promise((resolve, reject) => {
        let params = {};
        ConsoleController.getUserLoginList(params).then(res => {
          if (res.data && res.data.length > 0) {
            userInfoDate.value = res.data[0];
          }
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    };
    const loadTaskData = params => {
      console.log("params11112222", params);
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        }
      };
      //获取待审核任务条数
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(params).then(res => {
          dataStatistics.value.pendingReview = res.data.totalCount;
        }).catch(e => {
          reject(e);
        });
        //获取已处理任务条数
        FlowOperationController.listHistoricTask(params).then(res => {
          dataStatistics.value.reviewed = res.data.totalCount;
        }).catch(e => {
          reject(e);
        });
        const params2 = {
          pageParam: {
            pageNum: 1,
            pageSize: 10
          },
          flowWorkOrderDtoFilter: {},
          meetingRequestDtoFilter: {}
        };
        //获取会议信息数量
        // ConsoleController.listWorkOrderFlowMeetingRequest(params2)
        ConsoleController.listMeetingList(params2).then(res => {
          dataStatistics.value.meeting = res.data.length;
        }).catch(e => {
          reject(e);
        });
        const currentDate = moment().format('YYYY-MM-DD');
        const params1 = {
          ...params,
          pageParam: {
            pageNum: 1,
            pageSize: 10
          },
          currentDate: currentDate
          // flowStatus1:  "3",
        };
        //获取今日行程数量
        ConsoleController.weeklyScheduleList(params1).then(res => {
          dataStatistics.value.weeklySchedule = res.data.length;
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 获取个人安排信息数量
    const weeklyScheduleListData = (params, workType) => {
      if (params == null) params = {};
      let currentDate1 = moment().format('YYYY-MM-DD');
      if (params && Object.keys(params).length > 0) {
        currentDate1 = params;
      }
      if (workType == null || workType.value == 'person') {
        currentDate.value = currentDate1;
        getWeekDate(currentDate1);
        params = {
          ...params,
          pageParam: {
            pageNum: 1,
            pageSize: 10
          },
          currentDate: currentDate1,
          workType: "person"
          // flowStatus1:"3",
        };
      } else if (workType.value == 'leader') {
        if (leader_value.value == null) {
          ElMessage({
            message: '请选择人员信息！',
            type: 'warning',
            duration: 3000 // 可选：设置弹窗的显示时长（毫秒）
          });
          return;
        } else {
          params = {
            ...params,
            pageParam: {
              pageNum: 1,
              pageSize: 10
            },
            currentDate: currentDate1,
            userId: leader_value.value,
            workType: "leader"
            // flowStatus1:"3",
          };
        }
      }
      //获取今日行程数量
      return new Promise((resolve, reject) => {
        //获取今日行程数量
        ConsoleController.weeklyScheduleList(params).then(res => {
          weeklyScheduleList.value = res.data;
        }).catch(e => {
          reject(e);
        });
      });
    };
    //获取通知公告信息
    const getNoticeMessageList = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        }
      };
      //获取通知公告数量
      return new Promise((resolve, reject) => {
        //获取通知公告信息
        ConsoleController.listNoticeMessageList(params).then(res => {
          noticeMessageList.value = res.data;
        }).catch(e => {
          reject(e);
        });
      });
    };
    const handMeetingListChange = value => {
      getListMeetingList(value);
    };
    //获取会议公告信息
    const getListMeetingList = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        },
        currentDate: moment(meetingDate.value).format('YYYY-MM-DD')
      };
      //获取会议公告信息
      return new Promise((resolve, reject) => {
        //获取会议公告信息
        ConsoleController.listMeetingList(params).then(res => {
          meetingList.value = res.data;
          meetingListNumber.value = res.data.length;
        }).catch(e => {
          reject(e);
        });
      });
    };
    //定义会议日期
    const meetingDate = ref('');
    //点击个人工作安排和领导工作安排选项时触发的方法
    const handleClick = tab => {
      const workType = tab.props.name;
      if (workType === 'person') {
        weeklyScheduleListData();
      }
      if (workType === 'leader') {
        roleLeaders();
      }
    };
    //领导工作安排获取领导人员信息
    const roleLeaders = params => {
      if (params == null) params = {};
      let currentDate1 = moment().format('YYYY-MM-DD');
      currentDate.value = currentDate1;
      getWeekDate(currentDate1);
      // leader_value.value = null;
      // 获取待审核任务条数
      return new Promise((resolve, reject) => {
        // 获取今日行程数量
        ConsoleController.roleLeaders(params).then(res => {
          // 修改: 确保 res.data 是数组，并且包含 id 和 showName 字段
          if (Array.isArray(res.data) && res.data.length > 0) {
            work_options.value = res.data.map(item => ({
              id: item.id,
              showName: item.showName || item.name || '未知' // 确保 showName 存在
            }));
          } else {
            work_options.value = []; // 如果数据为空，清空数组
          }
        }).catch(e => {
          reject(e);
        });
        if (leader_value.value) {
          const params1 = {
            ...params,
            pageParam: {
              pageNum: 1,
              pageSize: 10
            },
            currentDate: currentDate1,
            userId: leader_value.value,
            workType: "leader"
            // flowStatus1: "3",
          };
          ConsoleController.weeklyScheduleList(params1).then(res => {
            weeklyScheduleList.value = res.data;
          }).catch(e => {
            reject(e);
          });
        } else {
          weeklyScheduleList.value = [];
        }
      });
    };
    //存储选中日期 默认今天
    const currentDate = ref('');
    const weekDate = ref(['', '']);
    //获取今天的日期
    const getToday = () => {
      return moment().format('YYYY-MM-DD');
    };
    //获取本周的开始日期和结束日期,以数组的形式存储
    const getWeekDate = date => {
      const startOfWeek = moment(date).startOf('week').format('YYYY-MM-DD');
      const endOfWeek = moment(date).endOf('week').format('YYYY-MM-DD');
      weekDate.value = [startOfWeek, endOfWeek];
      console.log('weekDate.value', weekDate.value);
    };
    //获取指定日期的上一周的开始日期和结束日期,以数组的形式存储
    const getPrevWeekDate = date => {
      const startOfLastWeek = moment(date).subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
      const endOfLastWeek = moment(date).subtract(1, 'week').endOf('week').format('YYYY-MM-DD');
      const lastWeekDate = [startOfLastWeek, endOfLastWeek];
      console.log('lastWeekDate', lastWeekDate);
      weekDate.value = lastWeekDate;
    };
    //获取指定日期的下一周的开始日期和结束日期,以数组的形式存储
    const getNextWeekDate = date => {
      const startOfNextWeek = moment(date).add(1, 'week').startOf('week').format('YYYY-MM-DD');
      const endOfNextWeek = moment(date).add(1, 'week').endOf('week').format('YYYY-MM-DD');
      const nextWeekDate = [startOfNextWeek, endOfNextWeek];
      weekDate.value = nextWeekDate;
      console.log('nextWeekDate', nextWeekDate);
    };
    //获取指定日期的Y|M|D
    const getYMD = (date, type) => {
      const year = moment(date).year(); // 获取年份 (YYYY)
      const month = moment(date).month(); // 获取月份 (0-11)，moment 的 month() 本身返回值已减 1
      const day = moment(date).date(); // 获取日期 (1-31)
      if (type === 'year') {
        return year;
      }
      if (type === 'month') {
        return month;
      }
      if (type === 'day') {
        return day;
      }
    };
    //上一周 本周 下一周 按钮选择
    const selectDate = type => {
      console.log("类型：", type);
      const date = moment(currentDate.value);
      switch (type) {
        case 'prev-week':
          // 往前一周，保持当前日期的星期几不变
          currentDate.value = date.subtract(7, 'days').format('YYYY-MM-DD');
          getPrevWeekDate(weekDate.value[0]);
          weeklyScheduleListData(currentDate.value);
          break;
        case 'next-week':
          // 往后一周，保持当前日期的星期几不变
          currentDate.value = date.add(7, 'days').format('YYYY-MM-DD');
          getNextWeekDate(weekDate.value[1]);
          weeklyScheduleListData(currentDate.value);
          break;
        case 'today':
          // 本周
          currentDate.value = getToday();
          getWeekDate(currentDate.value);
          break;
        default:
          break;
      }
    };
    const pendingReviewList = ref([]);
    const mattersCompletedList = ref([]);
    const ccMessageList = ref([]);
    const workActive = ref('work-1');
    const handleWorkClick = tab => {
      console.log("333333", tab);
      workActive.value = tab;
      if (tab === 'work-1') {
        createNewTaskList();
      } else if (tab === 'work-2') {
        work2Data();
      } else if (tab === 'work-3') {
        mattersCompletedData();
      } else if (tab === 'work-4') {
        ccMessageListData();
      }
    };
    //当workActive等于work-1我创建的选项是调用createNewTaskList接口
    const createNewTaskList = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        }
      };
      //查询当前用户所创建的数据
      return new Promise((resolve, reject) => {
        ConsoleController.createNewTaskList(params).then(res => {
          createTaskList.value = res.data;
        }).catch(e => {
          reject(e);
        });
      });
    };
    //当workActive等于work-2待我处理选项时调用work2Data接口
    const work2Data = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        },
        orderParam: {
          fieldName: 'entryId',
          sort: 'desc'
        }
      };
      // 获取待审核任务条数
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(params).then(res => {
          // 修改: 确保 res.data.dataList 是数组，避免 undefined 导致的错误
          pendingReviewList.value = Array.isArray(res.data.dataList) ? res.data.dataList : [];
        }).catch(e => {
          reject(e);
        });
      });
    };
    //当workActive等于work-3已处理选项时调用work2Data接口
    const mattersCompletedData = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        },
        orderParam: {
          fieldName: 'entryId',
          sort: 'desc'
        }
      };
      //获取已处理任务条数
      return new Promise((resolve, reject) => {
        FlowOperationController.listHistoricTask(params).then(res => {
          // 修改: 确保 res.data.dataList 是数组，避免 undefined 导致的错误
          mattersCompletedList.value = Array.isArray(res.data.dataList) ? res.data.dataList : [];
          console.log("mattersCompletedList.value", mattersCompletedList.value);
        }).catch(e => {
          reject(e);
        });
      });
    };
    //当workActive等于work-3已处理选项时调用work2Data接口
    const ccMessageListData = params => {
      if (params == null) params = {};
      params = {
        ...params,
        pageParam: {
          pageNum: 1,
          pageSize: 10
        },
        orderParam: {
          fieldName: 'entryId',
          sort: 'desc'
        },
        read: false
      };
      //获取已处理任务条数
      FlowOperationController.listCopyMessage(params).then(res => {
        // 修改: 确保 res.data.dataList 是数组，避免 undefined 导致的错误
        ccMessageList.value = Array.isArray(res.data.dataList) ? res.data.dataList : [];
        console.log("ccMessageList.value", ccMessageList.value);
      }).catch(e => {});
    };
    // // 修改方法：显示消息提示弹窗，并支持点击操作
    const fetchNoticeList = async () => {
      let params = {};
      FlowOperationController.listNoticeMessageList(params).then(res => {
        if (res.success == "yes") {
          // const showNotification = async () => {
          ElNotification({
            title: '通知公告',
            message: '您收到新的通知请注意查收！',
            position: 'bottom-right',
            duration: 5000,
            onClick: () => {
              // router.push('/notification/detail');
              let row = {
                id: '1',
                title: '通知公告',
                content: '通知公告已阅读',
                status: '已阅读'
              };
              onListOfAssetsListClick(row);
            }
          });
          // };
        }
      }).catch(e => {});
    };
    /**
     * 通知公告选择
     */
    const dialogVisible = ref(false);
    const dialogTitle = ref('通知公告');
    const dialogComponent = ref(ListOfAssetsList);
    const dialogProps = ref({});
    const onListOfAssetsListClick = row => {
      dialogVisible.value = true;
      dialogProps.value = {
        rowData: row
      };
      // router.push({
      //     name: 'wkcWeeklySchedule',
      //     query: {
      //       id: row.taskId,
      //     }
      //   })
    };
    onMounted(() => {
      // 初始化日期为今天
      currentDate.value = getToday();
      meetingDate.value = getToday();
      getWeekDate(currentDate.value);
      loadTaskData();
      getUserLoginList();
      // 自动弹出消息提示框
      fetchNoticeList();
      createNewTaskList();
      getListMeetingList();
      weeklyScheduleListData();
      getNoticeMessageList();
    });
    // 添加点击事件处理函数
    const handlePendingReviewClick = () => {
      // router.push('formMyTask'); // 跳转到功能页面
      router.push({
        name: 'formMyTask',
        query: {
          taskNme: "formMyTask" // 任务单号
        }
      });
    };
    const handleReviewedviewClick = () => {
      // router.push('formMyApprovedTask'); // 跳转到已办事宜功能页面
      router.push({
        name: 'formMyApprovedTask',
        query: {
          taskName: "formMyApprovedTask" // 任务单号
        }
      });
    };
    const handleMeetingviewClick = () => {
      // router.push('flowMeetingRequestOrder'); // 跳转到功能页面
      router.push({
        name: 'flowMeetingRequestOrder',
        query: {
          taskNames: "flowMeetingRequestOrder" // 任务单号
        }
      });
    };
    const handleWeeklyScheduleviewClick = () => {
      router.push('weekPlan'); // 跳转到功能页面
    };
    // 点击合同流转图标跳转到合同功能页面
    const handleNavigationClick = () => {
      // router.push('ContractAnagementFlow'); // 跳转到合同功能页面
      router.push({
        name: 'ContractAnagementFlow',
        query: {
          taskNme: "ContractAnagementFlow" // 任务单号
        }
      });
    };
    // 点击物资领用图标跳转到领用申请功能页面
    const handWkcAssetAcquisitionClick = () => {
      // router.push('WkcAssetAcquisition'); // 跳转到资产领用功能页面
      router.push({
        name: 'WkcAssetAcquisition',
        query: {
          taskNme: "WkcAssetAcquisition" // 任务单号
        }
      });
    };
    // 点击调休申请图标跳转到调休申请功能页面
    const handformTimeOffRouteOrderClick = () => {
      // router.push('formTimeOffRouteOrder'); // 跳转到调休申请功能页面
      router.push({
        name: 'formTimeOffRouteOrder',
        query: {
          taskNme: "formTimeOffRouteOrder" // 任务单号
        }
      });
    };
    // 点击用印申请图标跳转到用印申请功能页面
    const handUseSealRouteOrderClick = () => {
      // router.push('useSealRouteOrder'); // 跳转到用印申请功能页面
      router.push({
        name: 'useSealRouteOrder',
        query: {
          taskNme: "useSealRouteOrder" // 任务单号
        }
      });
    };
    // 点击加班申请图标跳转到加班申请功能页面
    const handFlowOvertimeOrderClick = () => {
      // router.push('flowOvertimeOrder'); // 跳转到加班申请功能页面
      router.push({
        name: 'flowOvertimeOrder',
        query: {
          taskNme: "flowOvertimeOrder" // 任务单号
        }
      });
    };
    const handleLeaderChange = value => {
      if (!value) {
        // 当用户选择清空时，将 leader_value 设置为 null
        leader_value.value = null;
        weeklyScheduleList.value = [];
      } else {
        // 其他逻辑保持不变
        const params = {
          pageParam: {
            pageNum: 1,
            pageSize: 10
          },
          currentDate: moment(currentDate.value).format('YYYY-MM-DD'),
          userId: value,
          workType: 'leader'
        };
        ConsoleController.weeklyScheduleList(params).then(res => {
          weeklyScheduleList.value = res.data;
        }).catch(e => {
          console.error(e);
        });
      }
    };
    const truncateContent = (content, maxLength) => {
      if (!content || typeof content !== 'string') {
        return ''; // 如果 content 为空或非字符串，返回空字符串
      }
      if (content.length > maxLength) {
        return content.substring(0, maxLength) + '...';
      }
      return content;
    };
    // 新增方法：处理日期点击事件
    const handleDateClick = date => {
      if (moment(date).isValid()) {
        weeklyScheduleListData(moment(date).format('YYYY-MM-DD'), workType);
      } else {
        console.error('Invalid date provided to handleDateClick');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_calendar = _resolveComponent("el-calendar");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_step = _resolveComponent("el-step");
      const _component_el_steps = _resolveComponent("el-steps");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(ElDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: dialogTitle.value,
        width: "80%",
        height: "80vh",
        "custom-class": "custom-dialog"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(dialogComponent.value), _normalizeProps(_guardReactiveProps(dialogProps.value)), null, 16))]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_row, {
        gutter: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
            src: _unref(headerImg) ? _unref(headerImg) : _unref(defaultHeaderImg),
            class: "header-img",
            style: {
              "width": "60px",
              "height": "60px"
            }
          }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, _toDisplayString((_unref(userInfo) || {}).showName), 1), _createElementVNode("p", _hoisted_6, _toDisplayString((userInfoDate.value || {}).post_name), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDateByStats((userInfoDate.value || {}).last_login_date)), 1), _createElementVNode("div", _hoisted_10, _toDisplayString((userInfoDate.value || {}).last_login_time), 1)])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_row, {
            gutter: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 5.5
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "w-[100%] h-[65px] bg-[#FDBC32] rounded-[8px] bg-[url('@/assets/img/welcome-pic-1.png')] bg-no-repeat bg-[length:30px_30px] bg-[position:10px_10px] pl-[35px]",
                onClick: handlePendingReviewClick
              }, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString((dataStatistics.value || {}).pendingReview), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 5.5
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "w-[100%] h-[65px] bg-[#A0DEA1] rounded-[8px] bg-[url('@/assets/img/welcome-pic-2.png')] bg-no-repeat bg-[length:30px_30px] bg-[position:10px_10px] pl-[35px]",
                onClick: handleReviewedviewClick
              }, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString((dataStatistics.value || {}).reviewed), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 5.5
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "w-[100%] h-[65px] bg-[#8792D3] rounded-[8px] bg-[url('@/assets/img/welcome-pic-3.png')] bg-no-repeat bg-[length:30px_30px] bg-[position:10px_10px] pl-[35px]",
                onClick: handleMeetingviewClick
              }, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString((dataStatistics.value || {}).meeting), 1)])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 5.5
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "w-[100%] h-[65px] bg-[#ED6360] rounded-[8px] bg-[url('@/assets/img/welcome-pic-4.png')] bg-no-repeat bg-[length:30px_30px] bg-[position:10px_10px] pl-[35px]",
                onClick: handleWeeklyScheduleviewClick
              }, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString((dataStatistics.value || {}).weeklySchedule), 1)])])]),
              _: 1
            })]),
            _: 1
          })]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_tabs, {
            modelValue: workType.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => workType.value = $event),
            class: "list-tabs",
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "个人工作安排",
              name: "person"
            }), _createVNode(_component_el_tab_pane, {
              label: "领导工作安排",
              name: "leader"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 2,
              class: "pt-[70px]"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ArrowLeft), {
                size: "16",
                color: "#767676",
                onClick: _cache[2] || (_cache[2] = $event => selectDate('prev-week'))
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 20
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_calendar, {
                modelValue: currentDate.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => currentDate.value = $event),
                range: [new Date(getYMD(weekDate.value[0], 'year'), getYMD(weekDate.value[0], 'month'), getYMD(weekDate.value[0], 'day')), new Date(getYMD(weekDate.value[1], 'year'), getYMD(weekDate.value[1], 'month'), getYMD(weekDate.value[1], 'day'))],
                onClick: _cache[6] || (_cache[6] = $event => handleDateClick(currentDate.value))
              }, {
                header: _withCtx(() => [_createElementVNode("span", _hoisted_27, _toDisplayString(_unref(moment)(currentDate.value).isValid() ? _unref(moment)(currentDate.value).format('YYYY-MM-DD') : 'Invalid date'), 1), _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[3] || (_cache[3] = $event => selectDate('today')),
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 今日 ")]),
                  _: 1
                }), workType.value === 'leader' ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: leader_value.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => leader_value.value = $event),
                  placeholder: leader_value.value,
                  class: "w-[100px] float-right",
                  onChange: handleLeaderChange,
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work_options.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.showName,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["modelValue", "range"])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 2,
              class: "pt-[70px]"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ArrowRight), {
                size: "16",
                color: "#767676",
                onClick: _cache[7] || (_cache[7] = $event => selectDate('next-week'))
              })]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_steps, {
            direction: "vertical",
            active: 1
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeklyScheduleList.value.slice(0, 5), (item, index) => {
              return _openBlock(), _createBlock(_component_el_step, {
                key: index
              }, {
                title: _withCtx(() => [_createElementVNode("span", _hoisted_30, "时间：" + _toDisplayString(item.start_time) + " - " + _toDisplayString(item.end_time), 1), _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  plain: "",
                  class: "float-right",
                  onClick: $event => handleDetailClick(item)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                  _: 2
                }, 1032, ["onClick"])]),
                description: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: truncateContent(item.content, 50),
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("h1", _hoisted_31, "内容：" + _toDisplayString(truncateContent(item.content, 50)), 1)]),
                  _: 2
                }, 1032, ["content"]), _createVNode(_component_el_tooltip, {
                  content: item.locations,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_32, " 地点：" + _toDisplayString(item.locations), 1), _hoisted_33]),
                  _: 2
                }, 1032, ["content"])]),
                icon: _withCtx(() => [_hoisted_34]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })])]), _hoisted_35])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "h-[150px] bg-white mb-[16px]"
              }, [_hoisted_36, _createElementVNode("div", {
                class: "grid grid-cols-5 gap-4"
              }, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "mx-auto w-[60px] h-[60px]",
                onClick: handleNavigationClick
              })]), _hoisted_37]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("img", {
                src: _imports_1,
                alt: "",
                class: "mx-auto w-[60px] h-[60px]",
                onClick: handWkcAssetAcquisitionClick
              })]), _hoisted_38]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("img", {
                src: _imports_2,
                alt: "",
                class: "mx-auto w-[60px] h-[60px]",
                onClick: handformTimeOffRouteOrderClick
              })]), _hoisted_39]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("img", {
                src: _imports_3,
                alt: "",
                class: "mx-auto w-[60px] h-[60px]",
                onClick: handUseSealRouteOrderClick
              })]), _hoisted_40]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("img", {
                src: _imports_4,
                alt: "",
                class: "mx-auto w-[60px] h-[60px]",
                onClick: handFlowOvertimeOrderClick
              })]), _hoisted_41])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", {
                class: "color-[#767676] text-[14px] float-right link-text",
                onClick: handleMessage
              }, [_createTextVNode(" 更多 "), _createVNode(_component_el_icon, {
                class: "arrow right"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
                _: 1
              })])]), _createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeMessageList.value.slice(0, 20), (item, index) => {
                return _openBlock(), _createBlock(_component_el_row, {
                  gutter: 20,
                  class: "px-[10px] leading-[36px]",
                  key: item.id
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 17
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                      content: item.title,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [_createElementVNode("div", {
                        class: "line-clamp-1 text-[14px] text-[#1a1a1a] hover:text-[#007DFF] cursor-pointer",
                        onClick: $event => handNoticeDetailsLick(item)
                      }, [index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_47, " new ")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(truncateContent(item.title, 20)), 1)], 8, _hoisted_46)]),
                      _: 2
                    }, 1032, ["content"])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 7,
                    class: "text-center text-[#aaaaaa] line-clamp-1 border-radius-[50%]"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.formatDateByStats(item.create_time)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))])])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_createVNode(_component_el_date_picker, {
                modelValue: meetingDate.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => meetingDate.value = $event),
                type: "date",
                placeholder: "选择日期",
                class: "meetingDate",
                onChange: _cache[9] || (_cache[9] = $event => handMeetingListChange(meetingDate.value))
              }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_52, [_hoisted_53, _createTextVNode(), _createElementVNode("span", _hoisted_54, _toDisplayString(meetingListNumber.value), 1)]), _createElementVNode("div", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetingList.value.slice(0, 5), (item, index) => {
                return _openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createVNode(_component_el_tooltip, {
                  content: item.meeting_title,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_58, _toDisplayString(truncateContent(item.meeting_title, 10)), 1)]),
                  _: 2
                }, 1032, ["content"]), _createElementVNode("div", _hoisted_59, [_createVNode(_component_el_tooltip, {
                  content: '发起人：' + item.show_name,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", _hoisted_60, " 发起人：" + _toDisplayString(truncateContent(item.show_name, 10)), 1)]),
                  _: 2
                }, 1032, ["content"]), _createVNode(_component_el_tooltip, {
                  content: '地点：' + item.meeting_place,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", _hoisted_61, " 地点：" + _toDisplayString(truncateContent(item.meeting_place, 10)), 1)]),
                  _: 2
                }, 1032, ["content"])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(item.meeting_date), 1), _createElementVNode("div", _hoisted_64, _toDisplayString(item.start_time) + " - " + _toDisplayString(item.end_time), 1)])]);
              }), 256))])])]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", _hoisted_65, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tabs, {
                modelValue: workActive.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => workActive.value = $event),
                class: "work-tabs",
                onClick: _cache[11] || (_cache[11] = $event => handleWorkClick(workActive.value))
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                  label: "我创建的",
                  name: "work-1"
                }), _createVNode(_component_el_tab_pane, {
                  label: "待我处理",
                  name: "work-2"
                }), _createVNode(_component_el_tab_pane, {
                  label: "我已处理",
                  name: "work-3"
                }), _createVNode(_component_el_tab_pane, {
                  label: "抄送我的",
                  name: "work-4"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), workActive.value === 'work-1' ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 20,
            class: "bg-[#F5F5F5] h-[40px] leading-[40px]"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 5
            }, {
              default: _withCtx(() => [_createTextVNode("申请类型")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("任务单号")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6,
              style: {
                "margin-left": "22px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("申请部门")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3,
              style: {
                "margin-left": "-10px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("任务状态")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 2,
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("操作")]),
              _: 1
            })]),
            _: 1
          })) : workActive.value === 'work-2' ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            gutter: 20,
            class: "bg-[#F5F5F5] h-[40px] leading-[40px]"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 5
            }, {
              default: _withCtx(() => [_createTextVNode("流程名称")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("任务单号")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("当前任务")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3
            }, {
              default: _withCtx(() => [_createTextVNode("发起人")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3
            }, {
              default: _withCtx(() => [_createTextVNode("操作")]),
              _: 1
            })]),
            _: 1
          })) : workActive.value === 'work-3' ? (_openBlock(), _createBlock(_component_el_row, {
            key: 2,
            gutter: 20,
            class: "bg-[#F5F5F5] h-[40px] leading-[40px]"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 5
            }, {
              default: _withCtx(() => [_createTextVNode("流程名称")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("任务单号")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("任务名称")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3
            }, {
              default: _withCtx(() => [_createTextVNode("发起人")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3
            }, {
              default: _withCtx(() => [_createTextVNode("操作")]),
              _: 1
            })]),
            _: 1
          })) : workActive.value === 'work-4' ? (_openBlock(), _createBlock(_component_el_row, {
            key: 3,
            gutter: 20,
            class: "bg-[#F5F5F5] h-[40px] leading-[40px]"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 5
            }, {
              default: _withCtx(() => [_createTextVNode("流程名称")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 5
            }, {
              default: _withCtx(() => [_createTextVNode("任务名称")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 4
            }, {
              default: _withCtx(() => [_createTextVNode("抄送人")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 6
            }, {
              default: _withCtx(() => [_createTextVNode("抄送时间")]),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "text-center font-bold",
              span: 3
            }, {
              default: _withCtx(() => [_createTextVNode("操作")]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_66, [workActive.value === 'work-1' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(createTaskList.value.slice(0, 50), (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              gutter: 20,
              class: "h-[40px] leading-[40px]",
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                class: "text-center",
                span: 5
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.process_definition_name,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(truncateContent(item.process_definition_name, 8)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-left",
                span: 6,
                style: {
                  "margin-left": "29px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.work_order_code,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(truncateContent(item.work_order_code, 22)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.dept_name,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(truncateContent(item.dept_name, 8)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.flow_status_name,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(truncateContent(item.flow_status_name, 8)), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 4
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "viewDetails",
                  onClick: $event => handleCreateTaskList(item),
                  plain: ""
                }, {
                  default: _withCtx(() => [_createTextVNode("查看")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_67, [workActive.value === 'work-2' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(pendingReviewList.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              gutter: 20,
              class: "h-[40px] leading-[40px]",
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                class: "text-center",
                span: 5
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.processDefinitionName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.processDefinitionName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-left",
                span: 6,
                style: {
                  "margin-left": "29px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.workOrderCode,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.workOrderCode), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.taskName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.taskName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.showName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.showName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 4
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "viewDetails",
                  onClick: $event => handPendingReviewListList(item),
                  plain: ""
                }, {
                  default: _withCtx(() => [_createTextVNode("查看")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_68, [workActive.value === 'work-3' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(mattersCompletedList.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              gutter: 20,
              class: "h-[40px] leading-[40px]",
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                class: "text-center",
                span: 5
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.processDefinitionName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.processDefinitionName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-left",
                span: 6,
                style: {
                  "margin-left": "29px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.workOrderCode,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.workOrderCode), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.name,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.name), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.showName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.showName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 4
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "viewDetails",
                  onClick: $event => handMattersCompletedListList(item),
                  plain: ""
                }, {
                  default: _withCtx(() => [_createTextVNode("查看")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, [workActive.value === 'work-4' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(ccMessageList.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_row, {
              gutter: 20,
              class: "h-[40px] leading-[40px]",
              key: index
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                class: "text-center",
                span: 5,
                style: {
                  "margin-left": "5px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.processDefinitionName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.processDefinitionName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-left",
                span: 6,
                style: {
                  "margin-left": "65px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.taskName,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.taskName), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 4,
                style: {
                  "margin-left": "-100px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.createUsername,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.createUsername), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  content: item.createTime,
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.createTime), 1)]),
                  _: 2
                }, 1032, ["content"])]),
                _: 2
              }, 1024), _createVNode(_component_el_col, {
                class: "text-center",
                span: 4,
                style: {
                  "margin-left": "-25px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "viewDetails",
                  onClick: $event => handCcMessageListList(item),
                  plain: ""
                }, {
                  default: _withCtx(() => [_createTextVNode("查看")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128)) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});